app.component('sideNav', {
    templateUrl: 'app/sidenav/sidenav.html',
    controller: function ($location, $window, $mdSidenav) {
        var $ctrl = this;
        $ctrl.sidenav_info = {
            "function" : [{
                "icon" : "app/common/svg/check_24px.svg",
                "title" : "食生活チェック",
                "description" : "これまでの食生活について、セルフチェックしてみましょう。",
                "path" : "/eatlife_check_top",
                "alt" : "eatlife_check",
                "color" : "#4CAF50",
                "link" : "0"
            },
            {
                "icon" : "app/common/svg/ic_restaurant_24px.svg",
                "title" : "食事バランス",
                "description" : "食事画像から、食事の栄養バランスをチェックしましょう。",
                "path" : "/foodbalance_basiccheck",
                "alt" : "foodbalance",
                "color" : "#009688",
                "link" : "0"
            },
            {
                "icon" : "app/common/svg/ic_assignment_24px.svg",
                "title" : "健診結果",
                "description" : "健康診断結果から医師と管理栄養士からのアドバイスを閲覧できます。",
                "path" : "/medical_main",
                "alt" : "medical",
                "color" : "#00BCD4",
                "link" : "0"
            },
            {
                "icon" : "app/common/svg/ic_restaurant_menu_24px.svg",
                "title" : "すこやかレシピ",
                "description" : "健康維持に役立つ料理レシピ情報を閲覧することができます。",
                "path" : "/recipe_main/0",
                "alt" : "recipe",
                "color" : "#2196F3",
                "link" : "0"
            },
            {
                "icon" : "app/common/image/hiulogo.png",
                "title" : "北海道情報大学",
                "description" : "北海道情報大学へのリンクです。",
                "path" : "http://www.do-johodai.ac.jp/",
                "alt" : "hiu",
                "link" : "1"
            },
            {
                "icon" : "app/common/image/hiscfw.png",
                "title" : "食の臨床試験",
                "description" : "北海道情報大学健康情報科学研究センターへのリンクです。",
                "path" : "https://healthy.do-johodai.ac.jp",
                "alt" : "foot_test",
                "link" : "1"
            },
            {
                "icon" : "app/common/image/ebetulogo.gif",
                "title" : "江別市ホームページ",
                "description" : "江別市ホームページです。",
                "path" : "http://www.city.ebetsu.hokkaido.jp/soshiki/hoken",
                "alt" : "ebetu_icon",
                "link" : "1"
            },
            {
                "icon" : "app/common/image/noastec_logo.png",
                "title" : "ノーステック財団",
                "description" : "ノーステック財団のホームページです。",
                "path" : "http://www.noastec.jp/",
                "alt" : "noastec_icon",
                "link" : "1"
            },
            {
                "icon" : "app/common/image/healthydo.png",
                "title" : "ヘルシーＤｏ",
                "description" : "ヘルシーＤｏへのリンクです。",
                "path" : "http://www.pref.hokkaido.lg.jp/kz/sss/ks/hyouziseido.htm",
                "alt" : "healthDo",
                "link" : "1"
            }]
        };
        $ctrl.changeLocation = function(path, link) {
            if( link == "0" ) {
                $location.path(path);
            }
            else {
                $window.open(path);
            }
            $mdSidenav('left').toggle();
        };
    }
});
